import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormPriceComponent } from './form.component';
import { FieldsModule } from '../../fields/fields.module';

@NgModule({
  declarations: [
    FormPriceComponent
  ],
  imports: [
    CommonModule,
    FieldsModule
  ], exports:[
    FormPriceComponent
  ]
})
export class FormPriceModule { }